import settings from '../../config/settings';
import axios from './axiosNonAuth';
import _ from 'lodash';

const {trackingApiBaseUrl} = settings;

export default class TrackingApi {
  static sendPageLoad({fingerprint: user, fingerprint2}, url, title, device, publisher) {
    return axios.post(`${trackingApiBaseUrl}/page-loads`, {user, fingerprint2, url, title, device, publisher});
  }

  static sendCardClick({fingerprint: user, fingerprint2}, type, destination, url, card, campaign, publisher, referrer = '') {
    return axios.post(`${trackingApiBaseUrl}/card-clicks`, {user, fingerprint2, type, destination, url, card, campaign, publisher, referrer});
  }

  static sendImpression({fingerprint: user, fingerprint2}, type, mode, renderer, card, campaign, publisher, showsPage, referrer = '', destination = '', phrase) {
    return axios.post(`${trackingApiBaseUrl}/impressions`,
      {user, fingerprint2, type, mode, renderer, card, campaign, publisher, showsPage, referrer, destination, phrase});
  }

  static sendCardRequest({fingerprint: user, fingerprint2}, card, campaign, type, requestMode, destination, userAgent = '', clientIp = '') {
    const headers = {};
    if (userAgent) headers['User-Agent'] = userAgent;
    if (clientIp) headers['Client-Ip'] = clientIp;

    return axios.post(`${trackingApiBaseUrl}/card-requests`,
      {user, fingerprint2, card, campaign, type, requestMode, destination},
      !_.isEmpty(headers) ? {headers} : undefined
    );
  }

  static sendRendererClick({fingerprint: user, fingerprint2}, type, renderer, card, campaign, publisher, showsPage, phrase, referrer) {
    return axios.post(`${trackingApiBaseUrl}/renderer-clicks`,
      {user, fingerprint2, type, renderer, card, campaign, publisher, showsPage, phrase, referrer});
  }

  static sendAdClicked({fingerprint: user, fingerprint2}, mode, renderer, campaign, publisher, url, title, referrer) {
    return axios.post(`${trackingApiBaseUrl}/ad-clicks`,
      {user, fingerprint2, mode, renderer, campaign, publisher, url, title, referrer});
  }

  static sendRedirect({fingerprint: user, fingerprint2}, card, campaign, action, type, url, device, destination, referrer = '', userAgent = '', clientIp = '') {
    const headers = {};
    if (userAgent) headers['User-Agent'] = userAgent;
    if (clientIp) headers['Client-Ip'] = clientIp;

    return axios.post(`${trackingApiBaseUrl}/redirects`,
      {user, fingerprint2, card, campaign, action, type, url, device, destination, referrer},
      {headers}
    );
  }

  static sendAdEvent({fingerprint: user, fingerprint2}, category, action, referrer, publisher, template, campaign, renderer, dataSource, product, data) {
    return axios.post(`${trackingApiBaseUrl}/ad-events`,
      {user, fingerprint2, category, action, referrer, publisher, template, campaign, renderer, dataSource, product, data});
  }
}
